import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PermissionResource implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fName: string,
    private fService: string
  ) {
    [fId, fName, fService].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get createdAt() {
    return this.fCreatedAt;
  }

  get name() {
    return this.fName;
  }

  get service() {
    return this.fService;
  }

  get updatedAt() {
    return this.fUpdatedAt;
  }
}
